module.exports = __webpack_public_path__ + "img/PKLogo.d84f9bb2.png";